module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-bored.d1d51a34.png";